import { getBranding } from "./branding";

export function shouldShowV4Enterprise(): boolean {
  const branding = getBranding();
  return branding?.v4Enterprise?.enabled ?? false;
}

export function openEnterpriseAppInNewTab(
  path: string = '/', 
  queryParams: Record<string, string | number | boolean> = {}
): void {
  const branding = getBranding();
  const baseUrl = branding?.v4Enterprise?.platformUrl || '';
  
  if (!baseUrl) {
    console.error('Enterprise platform URL not configured in branding');
    return;
  }
  
  const queryString = new URLSearchParams(queryParams as Record<string, string>).toString();
  const url = `${baseUrl}${path}${queryString ? '?' + queryString : ''}`;
  
  window.open(url, '_blank', 'noopener,noreferrer');
}